/* eslint-disable no-undef */
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            company_list: [
                {
                    id: 1,
                    name: "บริษัท นพดลพานิช จำกัด สำนักงานใหญ่"
                }
            ],
            branch_list: [
                {
                    id: 1,
                    name: "สำนักงานใหญ่"
                },
                {
                    id: 2,
                    name: "สาขาสันกำแพง"
                }
            ],
            zone_list: [
                {
                    id: 1,
                    name: "Home Mark"
                },
                {
                    id: 2,
                    name: "Drive Thru"
                }
            ],
            company_id: 1,
            branch_id: 1,
            zone: 1,
            show_type: 0
        };
    },
    methods: {
        setConfig() {
            let config = {
                "company_id": this.company_id,
                "branch_id": this.branch_id,
                "zone": this.zone,
                "show_type": this.show_type
            }
            localStorage.que_config = JSON.stringify(config)
            Swal.fire({
                icon: 'success',
                title: 'บันทึกสำเร็จ',
                showConfirmButton: false,
                timer: 2000
            })
        },
        goHome(){
            this.$router.push({ name: "main" });
        }
    },
    created() {
        this.company_id = JSON.parse(localStorage.que_config).company_id
        this.branch_id = JSON.parse(localStorage.que_config).branch_id
        this.zone = JSON.parse(localStorage.que_config).zone
        this.show_type = JSON.parse(localStorage.que_config).show_type
    },
    mounted() {
        console.log(this.company_id,this.branch_id, this.zone)
    }
};